<template lang="pug">
#allSport.modal.modal-bottom.fade.modal-common(tabindex='-1' role='dialog' aria-labelledby='allSport' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.modal-bottom-center(role='document')
    .modal-content
      .modal-header(@click="hideModal" :aria-label="$t('ui.cancel')")
        .icon
          i.fas.fa-arrow-left
        h5.modal-title {{ $t("ui.all_sports") }}
      .modal-body
        ul.list-group.allsport
          template(v-for="(sport, index) in order")
            template(v-if="!defaultExclude.includes(sport)")
              template(v-if="todayMenu[sport] && todayMenu[sport].tn > 0 || earlyMenu[sport] && earlyMenu[sport].tn > 0 || liveMenu[sport] && liveMenu[sport].tn > 0")
                li.list-group-item(@click="setMenu2x(sport)")
                  span.icon
                    ThemeImage(:src="'images/light/sport/blue/' + getSportsImage(sport)")
                  span {{ sportsName[sport] }} 
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import config from "@/config";
import mixinTypes from "@/library/mixinTypes";

export default {
  components: {
    toolBar,
    footerNav
  },
  mixins: [mixinTypes],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    menu1() {
      return this.$store.getters.menu1;
    },
    order() {
      return this.$store.state.layout.order.sports;
    },
    sports() {
      return Object.keys(this.$store.state.layout.sports);
    },
    sportsName() {
      return this.$store.state.layout.sports;
    },
    defaultExclude() {
      return config.defaultSportExclude;
    }
  },
  methods: {
    hideModal() {
      $("#allSport").modal("hide");
    },
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      this.$store.dispatch("layout/resetSelectLeague");
    },
    setDays(e) {
      if (config.day1.includes(e)) {
        this.$store.dispatch("layout/setSelectedDays", "1");
      } else {
        this.$store.dispatch("layout/setSelectedDays", "0");
      }
    },
    setMenu2x(e) {
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      if (this.menu0 == "parlay") {
        mi5["menu0"] = "parlay";
        mi5["menu1"] = "parlay";
        mi5["menu2"] = parseInt(e);
        mi5["menu3"] = "parlay";
      } else if (config.gamesList.includes(String(e))) {
        mi5["menu0"] = "all";
        mi5["menu1"] = "today";
        mi5["menu2"] = parseInt(e);
        mi5["menu3"] = "hdpou";
      } else {
        if(this.liveMenu[e] && this.liveMenu[e].tn > 0) {
          mi5["menu0"] = "live";
          mi5["menu1"] = "live";
          mi5["menu2"] = parseInt(e);
          mi5["menu3"] = "hdpou";
          var options = {};
          options[mi5["menu2"]] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: options });
        } else if(this.todayMenu[e] && this.todayMenu[e].tn > 0) {
          mi5["menu0"] = "all";
          mi5["menu1"] = "today";
          mi5["menu2"] = parseInt(e);
          mi5["menu3"] = "hdpou";
          config.applyWeekendTodayMarket(mi5, this.$dayjs().day(), this.$store);
        } else if(this.earlyMenu[e] && this.earlyMenu[e].tn > 0) {
          mi5["menu0"] = "all";
          mi5["menu1"] = "early";
          mi5["menu2"] = parseInt(e);
          mi5["menu3"] = "hdpou";
        }
      }

      var changed = false;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }

      if (changed) {
        this.setDays(parseInt(mi5["menu2"]));
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
      $("#allSport").modal("hide");
      this.$router.push("/prematch").catch(err => {});
    }
  }
};
</script>
